import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// Service worker disabled: el precache offline-first rompía la actualización
// del contenido dentro del WebView de iOS (servía bundles viejos con recursos
// http inseguros bloqueados por ATS). Lo desregistramos para que el WebView
// siempre tome la versión servida por CloudFront.
unregister();



// WEBPACK FOOTER //
// ./src/index.js